module.exports = __webpack_public_path__ + "img/excelerate-logo.489a5e6f.png";